import React, { FC, memo } from 'react'

import {
    AccommodationContainer,
    Container,
    FooterContainer,
    ImageContainer,
    InnerContainer,
    NextImageContainer,
    RegionTitleContainer,
    SeoHref,
} from './styles'
import { useTranslation } from '../../../../hooks/locale'
import NextImage from '../../../common/next-image'
import { preventDefaultHandler } from '../../../utils'
import { PopularDestinationTransport } from '../../../../transports/region-landing-page-transport'

const BestDestinationCard: FC<PopularDestinationTransport> = ({ url, title, imageUrl, count, noCrawl }) => {
    const { t } = useTranslation()

    return (
        <Container href={url} noCrawl={noCrawl} target={'_blank'} title={url}>
            <InnerContainer>
                <ImageContainer>
                    <NextImage
                        containerComponent={NextImageContainer}
                        src={imageUrl}
                        alt={title}
                        layout="responsive"
                        width={4}
                        height={3}
                    />
                </ImageContainer>
                <FooterContainer>
                    <RegionTitleContainer>
                        <SeoHref
                            href={url}
                            noCrawl={noCrawl}
                            target={'_blank'}
                            onClick={preventDefaultHandler}
                            title={title}
                            autoRedirect={false}
                        >
                            {title}
                        </SeoHref>
                    </RegionTitleContainer>
                    <AccommodationContainer>{`${count} ${
                        count === 1 ? t('accommodation') : t('accommodations')
                    }`}</AccommodationContainer>
                </FooterContainer>
            </InnerContainer>
        </Container>
    )
}

export default memo(BestDestinationCard)
